import { render, staticRenderFns } from "./plan_list.vue?vue&type=template&id=8d898f32&scoped=true"
import script from "./plan_list.vue?vue&type=script&lang=js"
export * from "./plan_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d898f32",
  null
  
)

export default component.exports